if (!customElements.get('collection-section')) {
    // js/sections/CollectionSection.js
    var import_fastdom4 = __toESM(require_fastdom());
    class CollectionSection extends HTMLElement {
    constructor() {
        super();
        this.delegateElement = new main_default(this);
        this.options = JSON.parse(this.getAttribute("data-section-settings"));
        this.currentUrl = new URL(window.location.href);
        this.mobileFilterDrawer = new CollectionFilterDrawer(this.options);
        this.displayByValuePicker = new ValuePicker("display-by-selector", { onValueSelect: this._showingCountChanged.bind(this) });
        this.sortByValuePicker = new ValuePicker("sort-by-selector", { onValueSelect: this._sortByChanged.bind(this) });
        this.productItemColorSwatch = new ProductItemColorSwatch(this);

        const globoOn = this._isGloboFilterActive();
        if (globoOn) return;

        if (window.theme.pageType === "search") {
        this._loadContentResults();
        }
        window.addEventListener("popstate", () => {
        this.currentUrl = new URL(window.location.href);
        this._reload(false);
        });
        this._attachListeners();
    }
    onUnload() {
        this.delegateElement.off();
        this.mobileFilterDrawer.destroy();
        this.displayByValuePicker.destroy();
        this.sortByValuePicker.destroy();
        this.productItemColorSwatch.destroy();
    }
    onSelect(event2) {
        if (Shopify.designMode && event2.detail.load) {
        this.querySelector(`.collection__layout-button[data-layout-mode="${this.options["defaultLayout"]}"]`).click();
        this._showingCountChanged(this.options["defaultProductsPerPage"]);
        }
    }
    _isGloboFilterActive() {
        // Check for common Globo artifacts (DOM & snippets)
        return !!document.querySelector(
        '.spf-product-card, #gf-products, .gf-filter-container'
        );
    }
    _attachListeners() {
        this.delegateElement.on("click", '[action="/cart/add"] button[type="submit"]', this._addToCart.bind(this));

        if (this._isGloboFilterActive()) return;

        this.delegateElement.on("click", '[data-action="change-layout"]', this._changeLayout.bind(this));
        this.delegateElement.on("change", "#mobile-sort-by, #desktop-sort-by", this._sortByChanged.bind(this));
        this.delegateElement.on("change", "#showing-count", this._showingCountChanged.bind(this));
        this.delegateElement.on("click", ".pagination [data-page]", this._paginationPageChanged.bind(this));
        this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this));
        this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this));
        this.delegateElement.on("change", '[name^="filter."]', this._onFilterChanged.bind(this));
        this.delegateElement.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this));
    }
    _openQuickView(event2, target) {
        let productUrl = new URL(`${window.location.origin}${target.getAttribute("data-product-url")}`);
        if (Responsive.matchesBreakpoint("phone") || Responsive.matchesBreakpoint("tablet")) {
        window.location.href = productUrl.href;
        return false;
        }
        let modal = document.getElementById(target.getAttribute("aria-controls"));
        modal.classList.add("is-loading");
        productUrl.searchParams.set("view", "quick-view");
        fetch(productUrl.href, {
        credentials: "same-origin",
        method: "GET"
        }).then((response) => {
        response.text().then((content) => {
            modal.querySelector(".modal__inner").innerHTML = content;
            modal.classList.remove("is-loading");
            let modalProductSection = new ProductSection(modal.querySelector('[data-section-type="product"]'));
            let doCleanUp = () => {
            modalProductSection.onUnload();
            modal.removeEventListener("modal:closed", doCleanUp);
            };
            modal.addEventListener("modal:closed", doCleanUp);
        });
        });
    }
    /**
     * Switch layout mode
     */
    _changeLayout(event2, target) {
        if (target.classList.contains("is-selected")) {
        return;
        }
        const newLayoutMode = target.getAttribute("data-layout-mode");
        fetch(`${window.routes.cartUrl}/update.js`, {
        body: JSON.stringify({
            attributes: {
            "collection_layout": newLayoutMode
            }
        }),
        credentials: "same-origin",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // This is needed as currently there is a bug in Shopify that assumes this header
        }
        });
        import_fastdom4.default.mutate(() => {
        Dom.getSiblings(target, ".is-selected").forEach((button) => button.classList.remove("is-selected"));
        target.classList.add("is-selected");
        this.querySelectorAll(".product-item").forEach((item) => {
            if (newLayoutMode === "grid") {
            item.className = `product-item product-item--vertical ${this.options["gridClasses"]}`;
            } else {
            item.className = "product-item product-item--list";
            }
        });
        this.productItemColorSwatch.recalculateSwatches();
        });
    }
    /**
     * Update the URL and reload products
     */
    _sortByChanged(value) {
        this.currentUrl.searchParams.set("sort_by", value);
        this.currentUrl.searchParams.delete("page");
        this._reload(true);
    }
    /**
     * When the number of items has changed
     */
    _showingCountChanged(value) {
        this.currentUrl.searchParams.delete("page");
        fetch(`${window.routes.cartUrl}/update.js`, {
        body: JSON.stringify({ attributes: { "collection_products_per_page": value } }),
        credentials: "same-origin",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // This is needed as currently there is a bug in Shopify that assumes this header
        }
        }).then(() => {
        this._reload(true);
        });
    }
    /**
     * When the page has changed
     */
    _paginationPageChanged(event2, target) {
        event2.preventDefault();
        this.currentUrl.searchParams.set("page", parseInt(target.getAttribute("data-page")));
        this._reload(true);
    }
    _onFilterChanged(event2, target) {
        const formData = new FormData(target.closest("form"));
        const searchParamsAsString = new URLSearchParams(formData).toString();
        this.currentUrl = new URL(`${window.location.pathname}?${searchParamsAsString}`, window.location.origin);
        this._reload(true);
    }
    _onFiltersCleared(event2, target) {
        this.currentUrl = new URL(target.getAttribute("data-url"), window.location.origin);
        this._reload(true);
    }
    /**
     * Reload all products from the current URL
     *
     * @private
     */
    _reload(pushState) {
        // if Globo is active just return
        if (this._isGloboFilterActive()) return Promise.resolve();
        if (this.abortController) {
        this.abortController.abort();
        }
        if (pushState) {
        window.history.pushState({ path: this.currentUrl.toString() }, "", this.currentUrl.toString());
        }
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        const computedStyles = window.getComputedStyle(document.documentElement);
        let sectionUrl = "";
        if (this.currentUrl.search) {
        sectionUrl = `${this.currentUrl.pathname}/${this.currentUrl.search}&section_id=${this.getAttribute("data-section-id")}`;
        } else {
        sectionUrl = `${this.currentUrl.pathname}?section_id=${this.getAttribute("data-section-id")}`;
        }
        try {
        this.abortController = new AbortController();
        return fetch(sectionUrl, {
            credentials: "same-origin",
            method: "GET",
            signal: this.abortController.signal
        }).then((response) => {
            response.text().then((content) => {
            let tempElement = document.createElement("div");
            tempElement.innerHTML = content;
            this.querySelector(".collection__dynamic-part").innerHTML = tempElement.querySelector(".collection__dynamic-part").innerHTML;
            let desktopFilters = this.querySelector("#desktop-filters-form"), mobileFilters = this.querySelector("#mobile-collection-filters"), previousMobileScrollTop = 0;
            if (mobileFilters) {
                previousMobileScrollTop = mobileFilters.querySelector(".collection-drawer__inner").scrollTop;
            }
            if (desktopFilters) {
                Array.from(this.querySelectorAll(".collection__filter-group-name[aria-controls]")).forEach((groupName) => {
                let newGroup = tempElement.querySelector(`[aria-controls="${groupName.getAttribute("aria-controls")}"]`);
                if (newGroup) {
                    if (groupName.getAttribute("aria-expanded") === "true") {
                    newGroup.setAttribute("aria-expanded", "true");
                    newGroup.nextElementSibling.setAttribute("aria-hidden", "false");
                    newGroup.nextElementSibling.style.height = "auto";
                    newGroup.nextElementSibling.style.overflow = "visible";
                    } else {
                    newGroup.setAttribute("aria-expanded", "false");
                    newGroup.nextElementSibling.setAttribute("aria-hidden", "true");
                    newGroup.nextElementSibling.style = "";
                    }
                }
                });
                desktopFilters.innerHTML = tempElement.querySelector("#desktop-filters-form").innerHTML;
                mobileFilters.innerHTML = tempElement.querySelector("#mobile-collection-filters").innerHTML;
                mobileFilters.querySelector(".collection-drawer__inner").scrollTop = previousMobileScrollTop;
                this.mobileFilterDrawer._computeDrawerHeight();
            }
            this.productItemColorSwatch.recalculateSwatches();
            const elementOffset = this.querySelector(".collection").getBoundingClientRect().top - 25 - parseInt(computedStyles.getPropertyValue("--header-is-sticky")) * parseInt(computedStyles.getPropertyValue("--header-height"));
            if (elementOffset < 0) {
                window.scrollBy({ top: elementOffset, behavior: "smooth" });
            }
            const countJson = JSON.parse(tempElement.querySelector("[data-collection-products-count]").innerHTML);
            let showingProductsCount = this.querySelector(".collection__products-count-showing");
            if (showingProductsCount) {
                showingProductsCount.innerHTML = countJson["showingCount"];
            }
            this.querySelector(".collection__products-count-total").innerHTML = countJson["productsCount"];
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
            });
        });
        } catch (e) {
        }
    }
    /**
     * ---------------------------------------------------------------------------------------------------
     * SEARCH PAGE SPECIFIC METHOD
     * ---------------------------------------------------------------------------------------------------
     */
    _loadContentResults() {
        let currentUrl = new URL(window.location.href);
        fetch(`${window.routes.searchUrl}?section_id=search-content&q=${currentUrl.searchParams.get("q")}&type=article,page`, {
        credentials: "same-origin"
        }).then((response) => {
        response.text().then((content) => {
            let linkSearchResults = this.querySelector(".link-search-results"), fakeDiv = document.createElement("div");
            fakeDiv.innerHTML = content;
            if (linkSearchResults && content.trim() !== "") {
            linkSearchResults.innerHTML = fakeDiv.firstElementChild.innerHTML;
            linkSearchResults.style.display = "block";
            }
        });
        });
    }
    /**
     * ---------------------------------------------------------------------------------------------------
     * INTERNAL CODE THAT HANDLE PRODUCT ADD TO CART
     * ---------------------------------------------------------------------------------------------------
     */
    _addToCart(event2, target) {
        if (window.theme.cartType === "page") {
        return;
        }
        event2.preventDefault();
        event2.stopPropagation();
        target.setAttribute("disabled", "disabled");
        document.dispatchEvent(new CustomEvent("theme:loading:start"));
        const formElement = target.closest('form[action*="/cart/add"]');
        const quantityInput = formElement.querySelector('[name="quantity"]');
        var quantity = parseInt((quantityInput && quantityInput.value) ? quantityInput.value : 1, 10);
        fetch(`${window.routes.cartAddUrl}.js`, {
        body: JSON.stringify(Form.serialize(formElement)),
        credentials: "same-origin",
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest"
            // This is needed as currently there is a bug in Shopify that assumes this header
        }
        }).then((response) => {
        target.removeAttribute("disabled");
        if (response.ok) {
            this.dispatchEvent(new CustomEvent("product:added", {
            bubbles: true,
            detail: {
                button: target,
                variant: null,
                quantity: quantity
            }
            }));
        } else {
            document.dispatchEvent(new CustomEvent("theme:loading:end"));
        }
        });
        event2.preventDefault();
    }
    };

    customElements.define('collection-section', CollectionSection);
}